/**
 * Rust style error handling for single promise
 * @param promise promise to handle
 * @returns array with result
 */
async function asyncWrap<R extends unknown, H extends Promise<R>>(promise: H) {
  try {
    const data = await promise;
    return [data, null] as const;
  } catch (err) {
    return [null, err] as const;
  }
}

export default asyncWrap;
